"use strict";

exports.__esModule = true;
exports.StyledCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledCard = (0, _styledComponents.default)(({
  children,
  contrast,
  error,
  outline,
  thin,
  rounded,
  shadow,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps,
  children: children
}))`
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    color: ${({
  theme
}) => theme.colors.card.text};
    background-color: ${({
  theme
}) => theme.colors.card.background};
    border: 2px solid ${({
  theme
}) => theme.colors.card.border};
    border-radius: 0;
    padding: ${({
  theme
}) => theme.space[5]};

    ${props => props.contrast && (0, _styledComponents.css)`
        color: ${({
  theme
}) => theme.colors.card.contrast.text};
        background-color: ${({
  theme
}) => theme.colors.card.contrast.background};
        border-color: ${({
  theme
}) => theme.colors.card.contrast.border};
    `}

    ${props => props.error && (0, _styledComponents.css)`
        color: ${({
  theme
}) => theme.colors.card.error.text};
        background-color: ${({
  theme
}) => theme.colors.card.error.background};
        border-color: ${({
  theme
}) => theme.colors.card.error.border};
    `}

    ${props => props.outline && (0, _styledComponents.css)`
        background-color: ${({
  theme
}) => theme.colors.transparent};
    `}

    ${props => props.thin && (0, _styledComponents.css)`
        border-width: 1px;
    `}

    ${props => props.rounded && (0, _styledComponents.css)`
        border-radius: ${({
  theme
}) => theme.borderRadius.small};
    `}

    ${props => props.shadow && (0, _styledComponents.css)`
        box-shadow: ${({
  theme
}) => theme.colors.card.boxShadow ? theme.colors.card.boxShadow : 'none'};
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
exports.StyledCard = StyledCard;